var rich_content_viewer_default = {
  "fontElementMap": "wDXsn",
  "wrapper": "YUc15",
  "pluginContainerMobile": "Ctmd8",
  "viewer": "z-DD8",
  "android": "_02M4O",
  "rootedTraversedContent": "hKIgZ",
  "atomic": "FeJC1",
  "toolbar": "B-upd",
  "block": "N8Lov"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
